import { useEffect } from 'react'

import { useEsri } from '../hooks'

import { HORRY_STREETS_MAP } from '../constants'

const esriReqs = ['esri/layers/MapImageLayer']

const RoadsLayer = ({ map, view }) => {
  const [ready, { MapImageLayer }] = useEsri(esriReqs)

  useEffect(() => {
    if (ready && map) {
      const roadsLayer = new MapImageLayer({
        url: HORRY_STREETS_MAP,
      })
      map.add(roadsLayer)
    }
  }, [ready, MapImageLayer, map])

  return null
}

export default RoadsLayer
